import { Box, Text, type BoxProps } from "@chakra-ui/react";

export const EarSectionSpacer = (props: BoxProps) => {
	return (
		<Box
			w="100%"
			borderBottom="solid 1px"
			borderColor="gray.200"
			py={props.py}
			my={props.my}
			position="relative"
		>
			{props.content && (
				<Text
					position="absolute"
					top="-13px"
					left="50%"
					bgColor={props.bgColor}
					px={2}
				>
					{props.content}
				</Text>
			)}
		</Box>
	);
};
